var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("new-transfer", {
        key: _vm.newTransferComponentKey,
        on: {
          refresh: function($event) {
            return _vm.forceRerenderTransferComponent()
          },
          refreshOnError: function($event) {
            return _vm.rerenderHistoryComponent()
          },
          errorMessage: _vm.setErrorMessage
        }
      }),
      _vm._v(" "),
      _c("list", {
        key: _vm.transferHistoryComponentKey,
        attrs: { "channel-type": "Wallet" }
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { color: "error" },
          model: {
            value: _vm.snackbarError,
            callback: function($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError"
          }
        },
        [
          _c("span", [_vm._v(_vm._s(this.errorMessage))]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { text: "" },
              on: {
                click: function($event) {
                  _vm.snackbarError = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1435a24b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1435a24b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transfers/Index.vue
// module id = null
// module chunks = 